import React, { useState } from 'react';
import { Paper, Box, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { format } from 'date-fns';
import { DealStage } from '../../../../utils/enums'
import DeleteIcon from '@mui/icons-material/Delete';


const StageHistory = ({ data }) => {
    return (
        <Paper elevation={0} sx={{ p: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                <h4>Stage History</h4>
            </Box>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell width={100}>Stage</TableCell>
                            <TableCell align="right">Amount</TableCell>
                            <TableCell align="right">Probability (%)</TableCell>
                            <TableCell align="right">Expected Revenue</TableCell>
                            <TableCell align="right">Closing Date</TableCell>
                            <TableCell align="right">Stage Duration</TableCell>
                            <TableCell align="right">Modified Time</TableCell>
                            <TableCell align="right">Modified By</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((row) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                {DealStage?.[row.stage]?.label || 'Unknown Stage'}
                                </TableCell>
                                <TableCell align="right">{row.amount}</TableCell>
                                <TableCell align="right">{row.probability}</TableCell>
                                <TableCell align="right">{row.expectedRevenue}</TableCell>
                                <TableCell align="right">
                                    {row.closingDate ? format(new Date(row.closingDate), 'MMMM do yyyy') : 'No closing date'}
                                </TableCell>
                                <TableCell align="right">{row.duration}</TableCell>
                                <TableCell align="right">{row.createdAt ? format(new Date(row.createdAt), 'MMMM do yyyy') : 'No creation date'}</TableCell>
                                <TableCell align="right">{row.createdBy}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default StageHistory;
